<template>
  <div
    :class="'tw-cursor-pointer tw-flex tw-items-center ' + $attrs.class"
    tabindex="0"
    :role="props.formType"
    :aria-checked="props.checked"
    @click="handleClick">
    <div 
      :class="[
        'tw-text-3xl tw-w-12 tw-h-12 tw-flex tw-items-center tw-justify-center tw-border tw-border-black', 
        {'tw-rounded-full': props.formType == 'radio'}, 
        {'tw-bg-orange-medium': (props.formType == 'radio' && props.checked) },
        {'tw-rounded-xl': props.formType != 'radio' },
      ]">
      <span v-if="props.checked && props.formType == 'checkbox'" 
        class="fa fa-check tw-text-orange-medium" />
    </div>
    <div
      :id="`label-${props.id}`"
      class="tw-text-2xl tw-text-black tw-font-bold tw-ml-4">
      {{ props.label }}
    </div>
  </div>
</template>

<script setup lang="ts"> 
const emit = defineEmits(['onChange'])
 
const props = defineProps({
  value: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  cssClass: {
    type: String,
    default: "",
  },
  checked: {
    type: Boolean,
    default: false,
  },
  id: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  formType: {
    type: String,
    default: 'checkbox'
  }
});
 
// const iconClass = computed(() => {
//   const { checked } = props;
//   return {
//     "tw-font-4xl check-box__icon": true,
//     "tw-font-4xl check-box__icon--checked": checked,
//   };
// });
 
const handleClick = () => {
  emit("onChange", props.id);
};
</script>